import {
    DEALER_LICENCE,
    DEALERS_CONTACT_PERSON_PARTICULARS,
    DEALERS_LICENCE_MAILING_ADDRESS,
    OTHER_DETAILS,
    EQUIPMENT_DETAILS,
    TECHNICAL_DATA_INFORMATION,
    EQUIPMENT_TECHNICAL_DATA_M2M,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA,
    EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS,
    EQUIPMENT_TECHNICAL_DATA_INTERNAL
} from 'common/application.const/Licence/MyLicence/SERLicence';
import { attachmentPayloadSetting, attachmentRetrieve, requestLicenceAttachment } from 'features/applicationPage/helpers';

export const formatSER = async (licenceDetails: any, caseTypeID: string, application?: string) => {
    let licence;
    let newDocs;
    let newPayload;
    let docsLic;

    let equipmentTypesThatShallBeRegisteredUnderTheSerScheme = [];
    let mandatoryImdaSpecNoDesc = [];
    let optionalImdaSpecNoDesc = [];
    let networkConnection = [];
    let appliedFor = [];
    let technology = [];
    let equipmentTechnicalDataRadiocomOthers = [];
    let equipmentTechnicalDataInternal = [];

    newDocs = [];
    for (const key in licenceDetails.LICSupportingDoc) {
        if (licenceDetails.LICSupportingDoc.hasOwnProperty(key)) {
            const doc = await requestLicenceAttachment(licenceDetails.LICSupportingDoc[key], caseTypeID);
            if (doc.ID) {
                const attachment = {
                    ID: doc.ID,
                    fileName: doc.fileName,
                    mimeType: doc.mimeType,
                    category: doc.category
                };
                newDocs.push(attachment);
            }
        }
    }

    newPayload = attachmentPayloadSetting(newDocs);
    docsLic = attachmentRetrieve(newPayload);

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.mandatoryEquipmentTypesUnderSerSchemeEquipmentType &&
        licenceDetails?.equipmentInfo[0]?.mandatoryEquipmentTypesUnderSerSchemeEquipmentType.length > 0
    ) {
        equipmentTypesThatShallBeRegisteredUnderTheSerScheme =
            licenceDetails?.equipmentInfo[0]?.mandatoryEquipmentTypesUnderSerSchemeEquipmentType?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc &&
        licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc.length > 0
    ) {
        mandatoryImdaSpecNoDesc = licenceDetails?.equipmentInfo[0]?.mandatoryImdaSpecNoDesc?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc &&
        licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc.length > 0
    ) {
        optionalImdaSpecNoDesc = licenceDetails?.equipmentInfo[0]?.optionalImdaSpecNoDesc?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.networkConnection &&
        licenceDetails?.equipmentInfo[0]?.networkConnection.length > 0
    ) {
        networkConnection = licenceDetails?.equipmentInfo[0]?.networkConnection?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.appliedFor &&
        licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.appliedFor.length > 0
    ) {
        appliedFor = licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.appliedFor?.map((i: any) => i.mixedValue);
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology.length > 0
    ) {
        technology = licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom?.pleaseSelectTechnology?.map(
            (i: any) => i.mixedValue
        );
    }

    if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers &&
        licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers.length > 0
    ) {
        equipmentTechnicalDataRadiocomOthers = licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomOthers?.map(
            (value: any, i: number) => ({
                'row-id': value?.rowId,
                'tx-freq-range': value?.txFreqRange ?? '-',
                'rx-freq-range': value?.rxFreqRange ?? '-',
                'rf-power-output': value?.rfPowerOutput ?? '-'
            })
        );
    }

     if (
        licenceDetails &&
        licenceDetails?.equipmentInfo[0]?.EquipmentTechnicalDataInternal &&
        licenceDetails?.equipmentInfo[0]?.EquipmentTechnicalDataInternal.length > 0
    ) {
        equipmentTechnicalDataInternal = licenceDetails?.equipmentInfo[0]?.EquipmentTechnicalDataInternal?.map(
            (value: any, i: number) => ({
                'row-id': i + 1,
                'capability': value?.Capability,
                'tx-freq-range': value?.txFreqRange ?? '-',
                'rx-freq-range': value?.rxFreqRange ?? '-',
                'rf-power-output': value?.rfPowerOutput ?? '-',
                'comments': value?.Comments ?? '-'
            })
        );
    }

    licence = {
        id: 'simplified-equipment-registration',
        formID: 'simplified-equipment-registration',
        hasError: true,
        title: application === 'IMDA-IRIS-Work-LICApplication' ? 'Application Details' : 'Licence Details',
        values: {
            [`${DEALER_LICENCE}-dealer-licence-no`]: licenceDetails?.applicationInformation?.dealerLicenceNo ?? '-',
            [`${DEALER_LICENCE}-dealer-licence-company-name`]: licenceDetails?.applicationInformation?.dealerSLicenceCompanyName ?? '-',
            [`${DEALER_LICENCE}-scheme-type`]: licenceDetails?.applicationInformation?.schemeType ?? '-',

            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonParticulars?.sameAsApplicantParticulars ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-name`]: licenceDetails?.contactPersonParticulars?.name ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-designation`]: licenceDetails?.contactPersonParticulars?.designation ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-email`]: licenceDetails?.contactPersonParticulars?.email ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-office-tel-number`]: licenceDetails?.contactPersonParticulars?.officeTelNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-mobile-number`]: licenceDetails?.contactPersonParticulars?.mobileNumber ?? '-',
            [`${DEALERS_CONTACT_PERSON_PARTICULARS}-fax-number`]: licenceDetails?.contactPersonParticulars?.faxNumber ?? '-',

            [`${DEALERS_LICENCE_MAILING_ADDRESS}-same-as-applicant-particulars`]:
                licenceDetails?.contactPersonAddress?.sameAsApplicantAddress ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-building-name`]: licenceDetails?.contactPersonAddress?.address?.buildingName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-postal-code`]: licenceDetails?.contactPersonAddress?.address?.postalCode ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-street-name`]: licenceDetails?.contactPersonAddress?.address?.streetName ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-block-house-no`]: licenceDetails?.contactPersonAddress?.address?.blockNo ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-floor-level`]: licenceDetails?.contactPersonAddress?.address?.floor ?? '-',
            [`${DEALERS_LICENCE_MAILING_ADDRESS}-unit`]: licenceDetails?.contactPersonAddress?.address?.unit ?? '-',

            [`${OTHER_DETAILS}-other-details`]: licenceDetails?.otherDetails ?? '-',
            [`${OTHER_DETAILS}-public-contact-no`]: licenceDetails?.otherDetails?.publicContactNo ?? '-',
            [`${OTHER_DETAILS}-remarks`]: licenceDetails?.otherDetails?.remarks ?? '-',

            [`${EQUIPMENT_DETAILS}-ser-scheme-equipment-type`]: equipmentTypesThatShallBeRegisteredUnderTheSerScheme ?? [],
            [`${EQUIPMENT_DETAILS}-mandatory-imda-spec-no-desc`]: mandatoryImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-optional-imda-spec-no-desc`]: optionalImdaSpecNoDesc ?? [],
            [`${EQUIPMENT_DETAILS}-review-and-confirmed-tech-spec`]:
                licenceDetails?.equipmentInfo[0]?.iWeHaveReviewedAndConfirmedThatTheTechnicalSpecification ?? '-',
            [`${EQUIPMENT_DETAILS}-equipment-description`]: licenceDetails?.equipmentInfo[0]?.equipmentDescription ?? '-',
            [`${EQUIPMENT_DETAILS}-brand-trade-name`]: licenceDetails?.equipmentInfo[0]?.brandTradeName ?? '-',
            [`${EQUIPMENT_DETAILS}-model-no`]: licenceDetails?.equipmentInfo[0]?.modelNo ?? '-',
            [`${EQUIPMENT_DETAILS}-marketing-name`]: licenceDetails?.equipmentInfo[0]?.marketingName ?? '-',
            [`${EQUIPMENT_DETAILS}-manufacturer-name`]: licenceDetails?.equipmentInfo[0]?.manufacturerNameCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-country-of-origin`]: licenceDetails?.equipmentInfo[0]?.countryOfOriginImportCountry ?? '-',
            [`${EQUIPMENT_DETAILS}-fee`]: licenceDetails?.equipmentInfo[0]?.fee ?? '-',
            [`${EQUIPMENT_DETAILS}-network-connection`]: networkConnection ?? [],

            [`${TECHNICAL_DATA_INFORMATION}-test-lab-name`]: licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.testLabName ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-test-report-no`]:
                licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.testReportNo ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-country-of-lab`]:
                licenceDetails?.equipmentInfo[0]?.technicalDataInformation?.countryOfLab ?? '-',
            [`${TECHNICAL_DATA_INFORMATION}-applied-for`]: appliedFor ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-sim-card-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.simCardProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-m2m-service-provider`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.m2MServiceProvider ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-projected-use-life-of-equipment`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.projectedUseLifeOfEquipment ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_M2M}-purposes-services-and-type-of-information`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataM2M?.purposesServicesAndTypeOfInformation ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-channel-spacing`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.channelSpacing ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_INFO}-sar-value-w-kg`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocomInfo?.sarValueWKg10G ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM}-please-select-technology`]: technology ?? [],

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_4G_LTE}-does-the-equipment-support-b40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom4GLte
                    ?.doesTheEquipmentSupportB4023002400MHzTddFrequencyBand ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_NSA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GNsa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN119201980MHz21102170MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n1`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN1 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN317101785MHz18051880MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n3`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN3 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN725002570MHz26202690MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n7`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN7 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN8880915MHz925960MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n8`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN8 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN26814849MHz859894MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n26`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN26 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN28703748MHz758803MHzFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n28`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN28 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN3825702620MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n38`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN38 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN4023002400MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n40`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN40 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7733004200MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n77`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN77 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN7833003800MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n78`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN78 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2572650029500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n257`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN257 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2582425027500MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n258`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN258 ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-does-the-equipment-support-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa
                    ?.doesTheEquipmentSupportN2612750028350MHzTddFrequencyBand ?? '-',
            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_5G_SA}-please-indicate-power-class-for-n261`]:
                licenceDetails?.equipmentInfo[0]?.equipmentTechnicalDataRadiocom5GSa?.pleaseIndicatePowerClassForN261 ?? '-',

            [`${EQUIPMENT_TECHNICAL_DATA_RADIOCOM_OTHERS}-list`]: equipmentTechnicalDataRadiocomOthers ?? [],
            [`${EQUIPMENT_TECHNICAL_DATA_INTERNAL}-list`]: equipmentTechnicalDataInternal ?? []
            
        }
    };

    return licence;
};

const serPayload = {
    formatSER
};

export default serPayload;
